module.exports = __webpack_public_path__ + "static/media/dummy-logo-four.5ddc223a.png";